import { useQuery } from '@apollo/react-hooks';

import { useEffect, useState } from 'react';

import { gql } from 'apollo-boost';
import useStoreViewCode from '../../app/hooks/useStoreViewCode';
import {useLocale} from '../../app/hooks/useLocale';
import config from '../../config';

const query = gql`
  {
    e72: cmsBlocks(
      identifiers: ["storage_hub_e72_claim", "storage_hub_e72_description"]
    ) {
      items {
        identifier
        content
      }
    }
    e77: cmsBlocks(
      identifiers: ["storage_hub_e77_claim", "storage_hub_e77_description"]
    ) {
      items {
        identifier
        content
      }
    }
  }
`;

export const useGetHubCmsBlocks = () => {
  const storeViewCode = useStoreViewCode();
  const locale = useLocale();
  const { data, loading, error } = useQuery(query, { 
    context: {
      headers: {
        Store: storeViewCode
      },
      uri: config.localizedGraphQlServerUrl(locale)
    }
   });

  const [cmsBlock, setCmsBlocks] = useState({ E72: {}, E77: {} });

  useEffect(
    () => {
      const blockIdentifierMap = {
        storage_hub_e72_claim: 'claim',
        storage_hub_e77_claim: 'claim',
        storage_hub_e72_description: 'description',
        storage_hub_e77_description: 'description'
      };
      const parseBlockIdentifier = id => blockIdentifierMap[id];
      const addCmsBlockItemToBlockMap = (blockMap = {}, item) => (
        (blockMap[parseBlockIdentifier(item.identifier)] = item.content),
        blockMap
      );
      const getBlockMapForHub = queryResultsForHub => {
        if (queryResultsForHub && queryResultsForHub.items) {
          return queryResultsForHub.items.reduce(addCmsBlockItemToBlockMap, {});
        }
        return {};
      };

      setCmsBlocks({
        E72: data && getBlockMapForHub(data.e72),
        E77: data && getBlockMapForHub(data.e77)
      });
    },
    [data]
  );

  return { data: cmsBlock, loading, error };
};

export default useGetHubCmsBlocks;